// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2067":"79c494fc","3804":"f9998432"}[chunkId] + ".chunk.css";
};